import React, { useState, memo } from 'react';
import { LegalModal } from './LegalModal';
export const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'privacy' | 'terms' | null>(null);
  const openModal = (type: 'privacy' | 'terms') => {
    setModalType(type);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setModalType(null);
  };
  return <>
      <footer className="bg-bttf-bg text-bttf-text border-t border-bttf-accent/30 py-8 relative z-40" data-id="element-165">
        <div className="absolute inset-0 bg-bttf-highlight/10 mix-blend-overlay" data-id="element-166"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-167">
          <div className="text-center mb-4 max-w-3xl mx-auto" data-id="element-168">
            <p className="text-bttf-subtext text-sm" data-id="element-169">
              © 2026 legendaryreads.com. All Rights Reserved. This book,
              including all original text, commentary, analysis, and
              compilation, is protected by copyright law. Unauthorized
              reproduction or distribution is prohibited. This is an unofficial
              fan publication not affiliated with, endorsed by, or licensed by
              Universal Pictures or Amblin Entertainment. Back to the Future™
              is a trademark of Universal City Studios LLC.
            </p>
          </div>

          <div className="text-center mb-4 max-w-3xl mx-auto border-t border-bttf-accent/20 pt-4" data-id="element-170">
            <p className="text-bttf-subtext text-xs" data-id="element-171">
              This site is not a part of the Facebook website or Facebook Inc.
              Additionally, this site is NOT endorsed by Facebook in any way.
              FACEBOOK is a trademark of FACEBOOK, Inc.
            </p>
          </div>

          <div className="border-t border-bttf-accent/20 pt-6 mt-6 text-center text-bttf-subtext text-sm" data-id="element-172">
            <div className="mt-2 relative z-50" data-id="element-173">
              <button onClick={() => openModal('privacy')} className="text-bttf-accent hover:text-bttf-primary mx-2 transition-colors cursor-pointer relative z-50" data-id="element-174">
                Privacy Policy
              </button>
              <button onClick={() => openModal('terms')} className="text-bttf-accent hover:text-bttf-primary mx-2 transition-colors cursor-pointer relative z-50" data-id="element-175">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>
      <LegalModal isOpen={modalOpen} onClose={closeModal} type={modalType} data-id="element-176" />
    </>;
};